import styled from 'styled-components'

export const StyledImg = styled.img`
  display: block;
  height: auto;
`

export const ImageContainer = styled.div`
  height: 154;
  display: flex;
  align-items: center;
`
